(() => {
  const initStickyCart = () => {
    const sticky = document.getElementById('lumin-sticky-atc');
    if (!sticky || sticky.dataset.initialized === 'true') return;
    sticky.dataset.initialized = 'true';
    const stickyButton = sticky.querySelector('.lumin-sticky-atc__button');
    const stickyButtonText = stickyButton?.querySelector('span');
    const stickyPrice = sticky.querySelector('.lumin-sticky-atc__price');
    let mainButton;
    let mainPrice;
    let buttonObserver;
    let priceObserver;

    const getMainButton = () => document.getElementById(sticky.dataset.mainButton)
      || document.querySelector('.product__info-container product-form button[name="add"]');
    const getMainPrice = () => document.getElementById(sticky.dataset.mainPrice)
      || document.querySelector('.product__info-container [id^="price-"]');

    const syncButton = () => {
      const nextButton = getMainButton();
      if (!nextButton) return;
      if (nextButton !== mainButton) {
        mainButton = nextButton;
        buttonObserver?.disconnect();
        buttonObserver = new MutationObserver(syncButton);
        buttonObserver.observe(mainButton, { attributes: true, childList: true, subtree: true });
      }
      stickyButton.disabled = mainButton.disabled;
      const text = mainButton.querySelector('span')?.textContent?.trim();
      if (stickyButtonText) stickyButtonText.textContent = !mainButton.disabled && sticky.dataset.buttonLabel ? sticky.dataset.buttonLabel : text;
    };

    const syncPrice = () => {
      const nextPrice = getMainPrice();
      if (!nextPrice || nextPrice === stickyPrice) return;
      if (nextPrice !== mainPrice) {
        mainPrice = nextPrice;
        priceObserver?.disconnect();
        priceObserver = new MutationObserver(syncPrice);
        priceObserver.observe(mainPrice, { childList: true, subtree: true, characterData: true });
      }
      stickyPrice.innerHTML = mainPrice.innerHTML;
      stickyPrice.querySelectorAll('.product-price-notice').forEach((notice) => notice.remove());
    };

    const setVisible = () => {
      const button = getMainButton();
      if (!button) return;
      const threshold = button.getBoundingClientRect().bottom + window.scrollY + Number(sticky.dataset.offset || 0);
      const visible = window.scrollY + window.innerHeight > 300 && window.scrollY > threshold;
      sticky.classList.toggle('show', visible);
      sticky.setAttribute('aria-hidden', String(!visible));
      document.body.style.paddingBottom = visible ? `${sticky.offsetHeight}px` : '';
    };

    stickyButton?.addEventListener('click', () => {
      syncButton();
      if (!mainButton || mainButton.disabled) return;
      stickyButton.classList.add('is-loading');
      mainButton.click();
      window.setTimeout(() => stickyButton.classList.remove('is-loading'), 1200);
    });
    syncButton();
    syncPrice();
    setVisible();
    window.addEventListener('scroll', setVisible, { passive: true });
    window.addEventListener('resize', setVisible, { passive: true });
    document.addEventListener('variant:change', () => { syncButton(); syncPrice(); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initStickyCart);
  else initStickyCart();
  document.addEventListener('shopify:section:load', initStickyCart);
})();
